// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-migration .data-migration-instructions[data-v-75d2f8e8],.data-migration .data-migration-introduce[data-v-75d2f8e8]{margin-bottom:var(--base-size-16)}", ""]);
// Exports
module.exports = exports;
